import { Component, inject, Signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { IxModule } from "@siemens/ix-angular";
import { ADMIN_ROLES } from "../core/consts/roles";
import { AuthorizationService } from "./../core/services/authorization.service";

@Component({
  selector: "app-main-dashboard",
  templateUrl: "./main-dashboard.component.html",
  styleUrls: ["./main-dashboard.component.scss"],
  imports: [RouterLink, IxModule, TranslatePipe],
})
export class MainDashboardComponent {
  public readonly isAdmin: Signal<boolean>;

  protected readonly authorization = inject(AuthorizationService);

  constructor() {
    this.isAdmin = toSignal(this.authorization.hasAnyRole(...ADMIN_ROLES), { initialValue: false });
  }
}
